export default "__VITE_ASSET__Do9HpgwN__"